import { render, staticRenderFns } from "./BackgroundOverall.vue?vue&type=template&id=01d04a15&scoped=true&"
import script from "./BackgroundOverall.vue?vue&type=script&lang=js&"
export * from "./BackgroundOverall.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundOverall.vue?vue&type=style&index=0&id=01d04a15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d04a15",
  null
  
)

export default component.exports